import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { AssignmentEventTypeEnum } from '../../../shared/enums/assignment-event-type.enum';
import { AssignmentStateService } from '../../services/assignment-state.service';
import { AssignmentsFilterStateService } from '../../services/assignments-filter-state.service';
import { AssignmentsFilterModalComponent } from '../assignments-filter-modal/assignments-filter-modal.component';

@Component({
    templateUrl: './my-assignments.component.html',
    styleUrl: './my-assignments.component.scss',
    providers: [AssignmentsFilterStateService]
})
export class MyAssignmentsComponent implements OnInit {

    modalRef?: BsModalRef;

    protected assignmentEventTypes = AssignmentEventTypeEnum;

    constructor(
        public assignmentsStateService: AssignmentStateService,
        private assignmentsFilterStateService: AssignmentsFilterStateService,
        private headerStateService: HeaderStateService,
        private bsModalService: BsModalService,
        private translocoService: TranslocoService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.myAssignmentsTitle'),
            this.translocoService.translate('main.header.myAssignmentsDescription'),
            '/assignments',
            'fa-solid fa-filter text-primary'
        );
    }

    ngOnInit(): void {
        this.registerEvents();

        let currentFilter = this.assignmentsStateService.upcomingAssignmentsFilterSubject.value;
        this.assignmentsStateService.loadUpcomingAssignments(currentFilter);
    }

    // Opening the FilterModal
    public openModal(): void {
        this.modalRef = this.bsModalService.show(AssignmentsFilterModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                isFilterForPastAssignmentEnabled: false
            }
        });
        this.modalRef.content.assignmentsFilterSubject = this.assignmentsStateService.upcomingAssignmentsFilterSubject;
        this.modalRef.content.loadSavedFilters();
    }

    // call only once in ngOnInit
    private registerEvents(): void {

        // Opening FilterModal in the Header
        this.headerStateService.getActionClickedEvent().subscribe((x) => {
            this.openModal();
        });

        this.assignmentsFilterStateService.getIsAnyFilterDisplayedEvent().subscribe(x => {
            this.headerStateService.updateIsActiveStatusIndicatorDisplayed(x);
        });
    }
}
